import {gsap} from "gsap";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

let smoother;

function smootherSetup() {
    if (!ScrollTrigger.isTouch) {
        smoother = ScrollSmoother.create({
            wrapper: '#smooth-wrapper',
            content: '.site-content',
            smooth: 1.8,
            effects: true,
            normalizeScroll: true,
            ignoreMobileResize: true
        });
    }
}

// anchor links
function scrollToEl(targetEl,offset=0){
    const currentScroll = window.pageYOffset | document.body.scrollTop;
    const targetPos = Math.round(targetEl.getBoundingClientRect().top);
    const adminBarEl = document.getElementById("wpadminbar");
    const adminBarHeight = !!adminBarEl ? adminBarEl.offsetHeight : 0;
    const scrollPos = targetPos - adminBarHeight + currentScroll - 20;
    scroll({
        top: scrollPos - (40 + offset),
        behavior: "smooth",
    });
}

document.addEventListener('DOMContentLoaded', (event) => {
    smootherSetup();

    // anchor links
    document.addEventListener( "click", function (e) {
        // loop parent nodes from the target to the delegation node
        for (var target = e.target; target && target != this; target = target.parentNode) {
            if (target.matches("a")) {
                const href = target.getAttribute("href");
                if (/^#/.test(href)) {
                    const hash = href.substring(href.indexOf("#"));
                    const hashTarget = document.getElementById(hash.substring(1));
                    if (hash !== "#" && hashTarget) {
                        e.preventDefault();
                        target.blur();
                        scrollToEl(hashTarget);
                    } else if (hash == "#") {
                        e.preventDefault();
                        target.blur();
                    }
                }
                break;
            }
        }
    }, false );

    if (window.location.hash) {
        // console.log(window.location.hash);
        ScrollSmoother.get().scrollTo(window.location.hash, true);
    }
});

export { smootherSetup, smoother };